import api from '../../api/index.js'

const state ={
    
}

const getters = {

}

const actions ={
    HtmlInfoGetHtmlInfoByKeyName({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/HtmlInfo/GetHtmlInfoByKeyName',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    }
}

const mutations ={


}

export default {
    state,
    getters,
    actions,
    mutations
}